<div class="frontpage-widget cover-image-mose">
    <div class="whitebox align-center">
        <div class="container">
            <h2 i18n>Velkommen til <span class="vd-brand"><span class="brand-bold-part">Grund</span>Risk</span></h2>
            <!-- <p class="text-dimmed">Screenings- og risikovurderingsværktøj for grundvandstruende forureninger i Danmark</p> -->
            <p class="text-dimmed">Risikovurderingsværktøj for grundvandstruende forureninger i Danmark</p>
            <div class="mt-4">
                <!-- <button class="btn btn-dark" routerLink="/draft-screening/find-draft" [hidden]="isExternalUser">SØG V1-KLADDE</button> -->
                <!-- <button class="btn btn-light" routerLink="/screening/search" [hidden]="isExternalUser">VURDÉR
                    SCREENINGER</button> -->
                <button class="btn btn-success" routerLink="/riskassessment/search" [hidden]="isExternalUser">FORETAG RISIKOBEREGNING</button>
                <button class="btn btn-success" routerLink="/riskassessment/external-location-overview"
                    [hidden]="!isExternalUser">FORETAG RISIKOBEREGNING</button>
                <button class="btn btn-success" routerLink="/riskassessment/search-calculation">VIS MINE RISIKOBEREGNINGER</button>

                <button class="btn btn-secondary" routerLink="/statistics" [hidden]="isExternalUser">SE
                    STATISTIK</button>
            </div>
        </div>
    </div>
</div>
<div class="frontpage-widget">
    <div class="container">
        <div class="row pb-5">

            <div class="col-sm-0 col-lg-1"></div>
            <div class="col-sm-12 col-lg-5">
                <div class="icon-list">
                    <div>
                        <p class="mb-1">
                            <span i18n>GrundRisk er et støtteværktøj til risikovurdering af forurenede grundes påvirkning af grundvandet. GrundRisk anvendes af regioner og rådgivere i forbindelse med regionernes undersøgelser. </span>
                        </p>
                        <p class="mb-1">
                            <span i18n>Værktøjet kan også understøtte vurderinger i forbindelse med private forureningssager (frivillige undersøgelser), og regionerne opfordrer til, at værktøjet også anvendes i denne forbindelse. </span>
                        </p>
                        <p>
                            <span i18n>Vær opmærksom på, at man ved påbudssager skal kontakte den relevante kommune for at få vejledning om, hvilket risikovurderingsværktøj der skal anvendes.</span>
                        </p>
                    </div>
                </div>
                <a class="btn btn-link mt-4" target="_blank"
                    href="https://mst.dk/affald-jord/jordforurening/grundvand-grundrisk/">
                    LÆS MERE
                </a>
            </div>

            <div class="col-sm-0 col-lg-1"></div>
            <div class="col-sm-12 col-lg-4">
                <img class="img-fluid pt-5 pl-1" src="assets/Forside.png" />
            </div>

            <div class="col-sm-0 col-lg-1"></div>

        </div>
    </div>
</div>
<div class="frontpage-widget cover-image-jordbasen-gray">
    <div class="whitebox blue align-center">
        <div class="container">
            <h2 i18n>Hvem står bag <span class="vd-brand"><span class="brand-bold-part">Grund</span>Risk</span>?</h2>
            <p class="text-dimmed mb-0">GrundRisk er udviklet af Miljøstyrelsen i samarbejde med DTU og Danmarks
                Miljøportal.</p>

        </div>
    </div>
</div>

<div class="frontpage-widget footer">
    <div class="container">
        <h5 class="linetext text-dimmed"><span i18n>Kontakt</span></h5>

        <p i18n>Hvis du har spørgsmål vedr. GrundRisk er du velkommen til at kontakte Danmarks Miljøportal <a class="pl-2" href="https://danmarksmiljoeportal.zendesk.com/hc/da/requests/new">Skriv til supporten</a> </p>
        <p i18n><a style="font-size: 0.8rem;" href="https://www.was.digst.dk/grundrisk-miljoeportal-dk">Webtilgængelighedserklæring</a></p>
    </div>
</div>